import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router);

const router = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '',
            component: () => import('./layouts/Main.vue'),
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: '/',
                    name: 'blank',
                    component: () => import(/* webpackChunkName: "blank" */ './views/Blank.vue'),
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue'),
                },
                {
                    path: '/clientes',
                    name: 'clientes',
                    component: () => import(/* webpackChunkName: "clientes" */ './views/Clientes.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Início', url: '/' },
                            { title: 'Clientes', active: true },
                        ],
                        pageTitle: 'Clientes',
                        create: {
                            buttonTitle: 'Novo Cliente',
                            url: '/clientes/novo'
                        }
                    },
                    children: [
                        {
                            path: '/clientes/novo',
                            name: 'novo',
                            component: import(/* webpackChunkName: "clientes" */ './views/Clientes.vue'),
                            meta: {
                                breadcrumb: [
                                    {title: 'Início', url: '/'}, {title: 'Clientes', url: '/clientes'}, {title: 'Novo', active: true}
                                ],
                                pageTitle: 'Nova Empresa'
                            }
                        },
                        {
                            path: '/clientes/:name',
                            name: 'edicao',
                            component: import(/* webpackChunkName: "clientes" */ './views/Clientes.vue'),
                            meta: {
                                breadcrumb: [
                                    {title: 'Início', url: '/'}, {title: 'Clientes', url: '/clientes'}, {title: 'edicao', active: true}
                                ],
                                pageTitle: 'Edição de Empresa'
                            }
                        }
                    ]
                },
                {
                    path: 'vendas/compania/:customerId?',
                    name: 'checkout',
                    component: () => import(/* webpackChunkName: "checkou" */ './views/Shop/Shop.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Início', url: '/' },
                            { title: 'vendas', active: false, url: '/vendas' },
                            { title: 'venda', active: true }
                        ],
                        pageTitle: 'Venda'
                    },
                    props: (route) => ({
                        custumer: route.params.customer,
                        ...route.params
                    })
                },
                {
                    path: 'vendas/empresa/:customerId/codigo/:order_id',
                    name: 'ordered',
                    component: () => import(/* webpackChunkName: "checkou" */ './views/Shop/Shop.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Início', url: '/' },
                            { title: 'vendas', active: false, url: '/vendas' },
                            { title: 'Detalhe', active: true }
                        ],
                        pageTitle: 'Venda'
                    }
                },
                {
                    path: '/vendas',
                    name: 'vendas',
                    component: () => import(/* webpackChunkName: "vendas" */ './views/Vendas.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Início', url: '/' },
                            { title: 'Vendas', active: true },
                        ],
                        pageTitle: 'Vendas'
                    },
                },
                {
                    path: '/tickets',
                    name: 'tickets',
                    component: () => import(/* webpackChunkName: "tickets" */ './views/Tickets.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Início', url: '/' },
                            { title: 'Tickets', active: true },
                        ],
                        pageTitle: 'Tickets'
                    },
                },
                {
                    path: '/comissoes',
                    name: 'comissoes',
                    component: () => import(/* webpackChunkName: "comissoes" */ './views/Comissoes.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Início', url: '/' },
                            { title: 'Comissões', active: true },
                        ],
                        pageTitle: 'Comissões',
                        showDateRangePicker: true
                    },
                },
                {
                    path: '/usuario',
                    name: 'usuario',
                    component: () => import(/* webpackChunkName: "usuario" */ './views/Usuario.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Início', url: '/' },
                            { title: 'Usuário', active: true },
                        ],
                        pageTitle: 'Usuário'
                    },
                },
            ],
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ './layouts/Login.vue')
        },
        {
            path: '/error-404',
            name: 'error',
            component: () => import(/* webpackChunkName: "error" */ './layouts/Error404.vue')
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/error-404'
        }
    ],
});


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            return next();
        }
        return next({path: '/login', query: {redirect: to.path}});
    } else if (to.fullPath === '/login' && store.getters.isLoggedIn) {
        return next({path: '/'});
    }
    next();
});


router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg');
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;
